import { render, staticRenderFns } from "./MetrcGlobalPref.vue?vue&type=template&id=299ab20c&scoped=true"
import script from "./MetrcGlobalPref.vue?vue&type=script&lang=js"
export * from "./MetrcGlobalPref.vue?vue&type=script&lang=js"
import style0 from "./MetrcGlobalPref.vue?vue&type=style&index=0&id=299ab20c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299ab20c",
  null
  
)

export default component.exports